import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_item_component = _resolveComponent("info-item-component")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.entity)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, { gutter: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { md: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_info_item_component, {
                  label: _ctx.$t('label.type')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.entity.containerType?.name), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { md: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_info_item_component, {
                  label: _ctx.$t('label.address')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.entity.locality) + ", " + _toDisplayString(_ctx.entity.province), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { md: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_info_item_component, {
                  label: _ctx.$t('label.country')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.entity.country), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}